import { Icon } from './Icons';

export function ThemeToggle({ theme, setTheme }) {
  return (
    <div className="theme-toggle" role="tablist" aria-label="Color theme">
      <button
        type="button"
        role="tab"
        aria-selected={theme === 'light'}
        className={`tt-btn${theme === 'light' ? ' is-active' : ''}`}
        onClick={() => setTheme('light')}
      >
        <Icon.Sun width="14" height="14" />
        Light
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={theme === 'dark'}
        className={`tt-btn${theme === 'dark' ? ' is-active' : ''}`}
        onClick={() => setTheme('dark')}
      >
        <Icon.Moon width="14" height="14" />
        Dark
      </button>
    </div>
  );
}
